import { memo } from 'react';
import styled from '@emotion/styled';

import NavLink from '../NavLink';

import type { Wws_Page } from '../../../../types/graphql';
import { useRouteBuilder } from '../../../../lib/hooks/useRouteBuilder';

interface DesktopNavItemProps {
  handleTracking(selection: string): void;
  // TODO: NonNullable could lead to bugs!
  page: Partial<Wws_Page>;
}

const DesktopNavLink = styled(NavLink)`
  margin: 0;
  padding: 8px 0;
`;

const NavItem = styled('li')`
  display: inline-block;
  list-style: none;
  padding: 0 8px;
`;

function DesktopNavItem({ page, handleTracking }: DesktopNavItemProps) {
  const { title, routeName } = page;

  const href = useRouteBuilder(routeName || '');

  const props = {
    href,
    as: href,
    desktop: true,
    handleTracking,
    title: title || '',
    route: routeName || '',
  };

  return (
    <NavItem>
      <DesktopNavLink {...props} />
    </NavItem>
  );
}

export default memo(DesktopNavItem);
